import { Input, InputProps } from "antd";

import defaultInputStyles from "../DefaultInput/input.module.css";
import styles from "./passwordInput.module.css";

export const PasswordInput: React.FC<InputProps> = (props) => {
  return (
    <label className={defaultInputStyles.inputBlock}>
      <Input.Password
        classNames={{
          suffix: `${styles.inputSuffix}`,
        }}
        className={`${defaultInputStyles.input} ${styles.input}`}
        variant="outlined"
        {...props}
        placeholder=""
      >
        {props.children}
      </Input.Password>
      {props.placeholder && (
        <span
          className={`${defaultInputStyles.label} ${styles.label} ${
            props.value !== "" && props.value !== undefined ? `${defaultInputStyles.labelTop} ${styles.labelTop}` : ""
          }`}
        >
          {props.placeholder}
        </span>
      )}
    </label>
  );
};
